












































import { createComponent, ref, onMounted, onUnmounted, SetupContext, watch } from '@vue/composition-api'
import dayjs from 'dayjs'
function calcExpirationTime(hour: number, min: number, seconds: number): string[] {
    const hours = (hour + '').padStart(2, '0')
    const mins = (min + '').padStart(2, '0')
    const finalSeconds = (seconds + '').padStart(2, '0')
    return [...hours.split(''), ...mins.split(''), ...finalSeconds.split('')]
}
interface InitProps {
    time: number
}
export interface CountDownVNODE {
    start: Function
}
export default createComponent({
    name: 'CountDown',
    props: {
        time: {
            type: String,
            default: 0,
        },
    },
    setup(props: InitProps, setupContext: SetupContext) {
        const expirationTime = ref(['0', '0', '0', '0', '0', '0'])
        const dayArr = ref<string[]>([])
        const timer = ref<number>()
        const start = () => {
            if (timer.value) {
                clearInterval(timer.value)
            }
            timer.value = setInterval(() => {
                if (dayjs(props.time).diff(dayjs(), 'second') < 0) {
                    clearInterval(timer.value)
                    dayArr.value = []
                    expirationTime.value = ['0', '0', '0', '0', '0', '0']
                    setupContext.emit('onTimeover')
                    return
                }
                const days = dayjs(props.time).diff(dayjs(), 'day')
                const hours = dayjs(props.time).diff(dayjs(), 'hour') % 24
                const mins = dayjs(props.time).diff(dayjs(), 'minute') % 60
                const seconds = dayjs(props.time).diff(dayjs(), 'second') % 60
                expirationTime.value = calcExpirationTime(hours, mins, seconds)
                dayArr.value = days > 0 ? days.toString().split('') : []
            }, 1000)
        }
        onMounted(() => {
            start()
        })
        watch(
            () => props.time,
            () => {
                start()
            },
            {
                lazy: true,
            }
        )
        onUnmounted(() => {
            clearInterval(timer.value)
        })
        return {
            start,
            expirationTime,
            dayArr,
        }
    },
})
